/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteTeamBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteTeamBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteTeamBudgetQueryParamOwner
>;

export type DeleteTeamBudgetRequest = {
  id: string;
  owner: DeleteTeamBudgetQueryParamOwner;
  orgId?: string | undefined;
};

export const DeleteTeamBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteTeamBudgetScope = ClosedEnum<typeof DeleteTeamBudgetScope>;

export const DeleteTeamBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteTeamBudgetOwner = ClosedEnum<typeof DeleteTeamBudgetOwner>;

/**
 * OK
 */
export type DeleteTeamBudgetResponseBody = {
  scope: DeleteTeamBudgetScope;
  scopeId: string;
  owner: DeleteTeamBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteTeamBudgetQueryParamOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetQueryParamOwner
> = z.nativeEnum(DeleteTeamBudgetQueryParamOwner);
/** @internal */
export const DeleteTeamBudgetQueryParamOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetQueryParamOwner
> = DeleteTeamBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteTeamBudgetRequest$inboundSchema: z.ZodType<
  DeleteTeamBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  owner: DeleteTeamBudgetQueryParamOwner$inboundSchema,
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type DeleteTeamBudgetRequest$Outbound = {
  id: string;
  owner: string;
  org_id?: string | undefined;
};

/** @internal */
export const DeleteTeamBudgetRequest$outboundSchema: z.ZodType<
  DeleteTeamBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteTeamBudgetRequest
> = z.object({
  id: z.string(),
  owner: DeleteTeamBudgetQueryParamOwner$outboundSchema,
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function deleteTeamBudgetRequestToJSON(
  deleteTeamBudgetRequest: DeleteTeamBudgetRequest,
): string {
  return JSON.stringify(
    DeleteTeamBudgetRequest$outboundSchema.parse(deleteTeamBudgetRequest),
  );
}
export function deleteTeamBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTeamBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteTeamBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTeamBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteTeamBudgetScope$inboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetScope
> = z.nativeEnum(DeleteTeamBudgetScope);
/** @internal */
export const DeleteTeamBudgetScope$outboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetScope
> = DeleteTeamBudgetScope$inboundSchema;

/** @internal */
export const DeleteTeamBudgetOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetOwner
> = z.nativeEnum(DeleteTeamBudgetOwner);
/** @internal */
export const DeleteTeamBudgetOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamBudgetOwner
> = DeleteTeamBudgetOwner$inboundSchema;

/** @internal */
export const DeleteTeamBudgetResponseBody$inboundSchema: z.ZodType<
  DeleteTeamBudgetResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  scope: DeleteTeamBudgetScope$inboundSchema,
  scope_id: z.string(),
  owner: DeleteTeamBudgetOwner$inboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    "scope_id": "scopeId",
  });
});
/** @internal */
export type DeleteTeamBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteTeamBudgetResponseBody$outboundSchema: z.ZodType<
  DeleteTeamBudgetResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteTeamBudgetResponseBody
> = z.object({
  scope: DeleteTeamBudgetScope$outboundSchema,
  scopeId: z.string(),
  owner: DeleteTeamBudgetOwner$outboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    scopeId: "scope_id",
  });
});

export function deleteTeamBudgetResponseBodyToJSON(
  deleteTeamBudgetResponseBody: DeleteTeamBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteTeamBudgetResponseBody$outboundSchema.parse(
      deleteTeamBudgetResponseBody,
    ),
  );
}
export function deleteTeamBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTeamBudgetResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteTeamBudgetResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTeamBudgetResponseBody' from JSON`,
  );
}
